<template>
    <div v-if="id === 'tab-placed'" class="tab-plan-devices">
        <template v-if="devices.length > 0">
            <plan-device-row v-for="device in devices" :key="device.id" placed :planId="planId"
                             :device="device" :selectedDevice="selectedDevice" @selectDevice="selectDevice"></plan-device-row>
        </template>
        <p v-else>Aucun dispositif placé sur le plan.</p>
    </div>
    <div v-else-if="id === 'tab-remnants'" class="tab-plan-devices mt-2">
        <template v-if="remnantsDevices().length > 0">
            <plan-device-row v-for="device in remnantsDevices()" :key="device.id" :planId="planId"
                             :device="device" :selectedDevice="selectedDevice" @selectDevice="selectDevice"></plan-device-row>
        </template>
        <p v-else>Aucun dispositif restant.</p>
    </div>
</template>

<script>
import PlanDeviceRow from "@/pages/Sites/Devices/Plans/components/PlanDeviceRow";
export default {
    name: "PlanDeviceTab",
    components: {
        PlanDeviceRow
    },
    props: {
        id: String,
        planId: Number,
        devices: Array,
        site: Object,
        selectedDevice: Object
    },
    methods: {
        selectDevice(e) {
            this.$emit('selectDevice', { deviceId: e.deviceId })
        },
        remnantsDevices() {
            return this.site.devices.filter(device => { return device.plan_id === null || device.plan_id !== this.planId })
        },
    }
}
</script>

<style scoped lang="scss">
.tab-plan-devices {
    min-height: 250px;
    max-height: 550px;
    overflow-y: auto;
}
</style>
